import { Card, List, Row, Skeleton, Stack } from '@leanin/ui';

// Matches AdminJoinRequestsCard shape: a list of pending-request rows, each
// with an avatar, name + sublabel, optional pullquote area, and the
// approve/decline action stack on the right.

export function AdminJoinRequestsCardSkeleton({
  rows = 3,
}: {
  rows?: number;
}) {
  return (
    <Card pad="flush">
      <List bordered={false}>
        {Array.from({ length: rows }, (_, i) => (
          <Row key={i} gap="lg" align="flex-start" wrap p="xl">
            <Row
              gap="md"
              align="flex-start"
              style={{ flex: '2 1 360px', minWidth: 0 }}
            >
              <Skeleton width={44} height={44} rounded="full" style={{ flexShrink: 0 }} />
              <Stack gap="sm" style={{ flex: 1, minWidth: 0 }}>
                <Skeleton width="40%" height={16} rounded="sm" />
                <Skeleton width="64%" height={13} rounded="sm" />
                <Skeleton width="92%" height={48} rounded="md" />
              </Stack>
            </Row>
            <Stack gap="sm" ps="md" style={{ flex: '1 1 200px', minWidth: 200 }}>
              <Skeleton width={96} height={20} rounded="full" />
              <Skeleton width="100%" height={32} rounded="md" />
              <Row gap="sm">
                <Skeleton width="100%" height={32} rounded="md" style={{ flex: 1 }} />
                <Skeleton width="100%" height={32} rounded="md" style={{ flex: 1 }} />
              </Row>
            </Stack>
          </Row>
        ))}
      </List>
    </Card>
  );
}
